import axios from 'axios'

// state
export const state = {
  isLoginProcessing: false,
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  loginStart(state) {
    state.isLoginProcessing = true
  },
  loginSuccess(state) {
    state.isLoginProcessing = false
  },
  loginFail(state) {
    state.isLoginProcessing = false
  },
}
// actions
export const actions = {
  async postLogin({ commit, dispatch }, payload) {
    let token = null
    try {
      commit('loginStart')
      token = await axios.post(`auth/login`, payload)
      commit('loginSuccess')
      dispatch('auth/storeToken', token, { root: true })

      const response = await axios.get('auth/check')
      commit('auth/fetchUserSuccess', { user: response.user }, { root: true })

      dispatch('prizes/wins/fetchUnseenWins', {}, { root: true })
      // if (!response.user.is_how_to_play_shown) {
      //   dispatch('profile/howToPlay/openHowToPlayModal', {}, { root: true })
      // }
      // else {
      //   if (!response.user.email_verified_at) {
      //     dispatch('profile/emailValidation/openEmailValidationModal', {}, { root: true })
      //   }
      // }
    } catch (e) {
      commit('loginFail')
    }
    return token
  },
}
